import React from "react";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import {
  REGIONS_URL,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";
import PublicIcon from '@mui/icons-material/Public';

function RegionsListing() {
  const attributes = [{ key: "name", label: "Region Name", flex: 2 }];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);

  return (
    <GenericItemsListing
      items_URL={REGIONS_URL}
      title="Regions"
      name="Region"
      icon={<PublicIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
      uniqueId={"id"}
      isViewerOnly = {true}
    />
  );
}

export default RegionsListing;
